import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Device from "../views/Device.vue";
import Alarm from "@/views/Alarm.vue";
import Inform from "@/views/Inform.vue";
import Data from "../views/DataCenter.vue"
import Billing from "../views/Billing.vue";
import VirtualReality from "../views/VirtualReality.vue";
import RTL from "../views/Rtl.vue";
import Profile from "../views/Profile.vue";
import Message from "../views/Message.vue"
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import NotificationChannel from "@/views/NotificationChannel.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard-default",
  },
  {
    path: "/dashboard-default",
    name: 'routesMenu.homePage',
    component: Dashboard,
  },
  {
    path: "/data",
    name: 'routesMenu.data',
    component: Data,
  },
  {
    path: "/device",
    name: 'routesMenu.device',
    component: Device,
  },
  {
    path: "/alarm",
    name: 'routesMenu.alarm',
    component: Alarm,
  },
  {
    path: "/inform",
    name: 'routesMenu.inform',
    component: Inform,
  },
  {
    path: "/notification",
    name: 'routesMenu.notification',
    component: NotificationChannel,
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
  },
  {
    path: "/virtual-reality",
    name: "Virtual Reality",
    component: VirtualReality,
  },
  {
    path: "/rtl-page",
    name: "RTL",
    component: RTL,
  },
  {
    path: "/profile",
    name: 'routesMenu.me',
    component: Profile,
  },
  {
    path: "/message",
    name: 'routesMenu.message',
    component: Message,
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
